import type { AssetStoryblok } from "@/types/blok-types";

export const assetIsImage = (asset: AssetStoryblok) =>
  asset.filename.match(/.p?jpe?g?$|.a?png$|.gif$|.webp$|.avif$/i);

export const assetIsSvg = (asset: AssetStoryblok) =>
  asset.filename.match(/.svg$/i);
